<script>
  import pessoaServico from '~modulos/pessoa/servico';
  import DadosCadastrais from './compartilhado/FormDadosCadastrais.vue';
  import DadosPagamento from './compartilhado/FormDadosPagamento.vue';
  import DadosBancarios from './compartilhado/FormDadosBancarios.vue';
  import solicitacaoPagamentoServico from '../../servico';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
  import Termo from './compartilhado/FormTermo.vue';
  import Radio from '~componentes/Radio.vue';
  import { checkbox } from 'vue-strap';
  
  export default {
    components: { DadosCadastrais, DadosPagamento, DadosBancarios, AdicionarArquivos, ListaDeArquivos, checkbox, Radio, Termo },
    data() {
      return {
        documento: '',
        mostrarFormulario: false,
        solicitacao: this.camposSolicitacao(),
        carregando: false,
        dadosBancarios: [],
        dadosBancariosPIX: [],
        configuracao: this.$storage.configuracao(),
        arquivos: [], 
        desabilitarBeneficiario: false,
      }
    },
    mounted() {
      this.$root.tituloDaPagina = `Solicitação de Pagamento de Pessoa Física - ${this.$route.params.id ? 'Editar #' + this.$route.params.id : 'Nova'}`;
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'solicitacao-pagamento-pf.nova';
    },
    methods: {
      buscaDesabilitarBeneficiario() {
        if (this.configuracao.permissaoAlteracaoNomeBeneficiario != 0)
          return false;

        if (!this.solicitacao.documentoTerceiro)
          return false;

        return pessoaServico
          .busca(this.solicitacao.documentoTerceiro)
          .then(pessoa => {
            if (pessoa.nomePessoaFisicaJuridica)
              this.desabilitarBeneficiario = true;
          })
          .catch(error => {
            });
      },
      buscarBeneficiario() {
        $('#avancar').button('loading');
        
        return pessoaServico
          .busca(this.documento)
          .then(pessoa => {
            $('#avancar').button('reset');
            
            this.solicitacao.documentoTerceiro = pessoa.cpfCnpj; 
            this.solicitacao.nomeTerceiro = pessoa.nomePessoaFisicaJuridica.substring(0, 100);
            this.solicitacao.endereco = pessoa.endereco.substring(0, 100);
            this.solicitacao.numero = pessoa.numero.substring(0, 10);
            this.solicitacao.complemento = pessoa.complemento.substring(0, 80);
            this.solicitacao.bairro = pessoa.bairro.substring(0, 80);
            this.solicitacao.cidade = pessoa.cidade.substring(0, 60);
            this.solicitacao.uf = pessoa.estado.substring(0, 2);
            this.solicitacao.cep = pessoa.cep;
            this.solicitacao.pisPasep = pessoa.pisPasep;
            this.solicitacao.telefoneResidencial = pessoa.telefone1;
            this.solicitacao.telefoneComercial = pessoa.telefone2;
            this.solicitacao.fax = pessoa.fax;
            this.solicitacao.emailTerceiro = pessoa.email.substring(0, 300);
            this.solicitacao.inss = pessoa.inss;
            this.solicitacao.identidade = pessoa.identidadeInscEstadual.substring(0, 20);
            this.solicitacao.dataNascimento = this.$options.filters.formatarNumeroEmData(pessoa.dataNascimento);
            this.dadosBancarios = pessoa.dadosBancarios;
            this.dadosBancariosPIX = pessoa.dadosBancariosPIX;
            this.solicitacao.numCmc = pessoa.cmc.substring(0, 30);

            if (this.solicitacao.inss) {
              this.solicitacao.inss = this.solicitacao.inss.replace('   .     .  / ', "");
            }

            if (this.solicitacao.pisPasep) {
              this.solicitacao.pisPasep = this.solicitacao.pisPasep.replace('   .     .  / ', "");
            }

            this.solicitacao.pertenceQuadro = (pessoa.tipoQuadro > 0);

            if (pessoa.tipoQuadro > 0)
              this.solicitacao.tipoQuadro = pessoa.tipoQuadro;
            else
              this.solicitacao.tipoQuadro = null;

            this.solicitacao.cargo = pessoa.cargo;
            this.solicitacao.departamento = pessoa.departamento;
            this.solicitacao.cnpjInstituicaoPublica = pessoa.cnpjInstituicaoPublica;
            this.solicitacao.instituicaoPublica = pessoa.instituicaoPublica;
            this.solicitacao.cargaHorariaInstituicao = pessoa.cargaHorariaInstituicao;
            this.solicitacao.unidade = pessoa.unidade;
            this.solicitacao.tipoQuadroUSP = pessoa.tipoQuadroUSP;
            this.solicitacao.regimeTrabalhoUSP = pessoa.regimeTrabalho;
            this.solicitacao.matricula = pessoa.matriculaPessoa;

            if (pessoa.funcionarioPublico != null) {
              if (pessoa.funcionarioPublico == true)
                this.solicitacao.funcionarioPublico = 1;

              if (pessoa.funcionarioPublico == false)
                this.solicitacao.funcionarioPublico = 0;
            }

            if (pessoa.pertenceQuadroUSP != null) {
              if (pessoa.pertenceQuadroUSP == true)
                this.solicitacao.pertenceQuadroUSP = 1;

              if (pessoa.pertenceQuadroUSP == false)
                this.solicitacao.pertenceQuadroUSP = 0;
            }
            
            this.$set(this, 'mostrarFormulario', true);
            this.mostrarInstrucoes();
            this.buscaDesabilitarBeneficiario();
          })
          .catch(error => {
            $('#avancar').button('reset');
			
            this.solicitacao.documentoTerceiro = this.documento;
            
			      this.$set(this, 'mostrarFormulario', true);
			      this.mostrarInstrucoes();
          });
      },
      validarBeneficiario() {
        this.$validator
          .validate('documento', this.documento)
          .then(valido => {
            if (!valido) throw new Error("validacao");
          })
          .then(this.buscarBeneficiario)
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      mostrarInstrucoes() {
        if (!this.configuracao.instrucoesSolPagamentoPF || this.$route.params.id) return;
        
        this.$swal({
          title: 'Instruções da solicitação',
          html: this.configuracao.instrucoesSolPagamentoPF.replace(/\r\n/g, '<br>'),
          type: 'info',
          confirmButtonText: 'Ok, entendi!',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      },
      salvar() {
        $('#salvar').button('loading');
        var solBolsaObrigatorioPISInss = this.configuracao.solBolsaObrigatorioPISInss
        
        this.$refs.dadosCadastrais
          .validar()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
            }
            
            return valido;
          })
          .then(this.validarModalidadePagamentoSelecionada)
          .then(valido => {
            if (!this.solicitacao.pagamentoDeBolsa) {
              if (!this.solicitacao.pertenceQuadro && (this.solicitacao.pisPasep === '' && this.solicitacao.inss === '') && this.configuracao.obrigatorioPisPasepInssWeb) {
                this.$swal('', 'Preencha o PIS/PASEP ou o INSS.', 'info');
                $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
                throw new Error("validacao");
              }
            }
            else {
              if (solBolsaObrigatorioPISInss) {
                if (!this.solicitacao.pertenceQuadro && (this.solicitacao.pisPasep === '' && this.solicitacao.inss === '')) {
                  this.$swal('', 'Preencha o PIS/PASEP ou o INSS.', 'info');
                  $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
                  throw new Error("validacao");
                }
              }
            }
            
            return valido;
          })
          .then(valido => {
            if (!this.solicitacao.pagamentoDeBolsa) {
              if (!this.solicitacao.pertenceQuadro && (this.solicitacao.pisPasep === this.solicitacao.inss) && this.configuracao.obrigatorioPisPasepInssWeb) {
                this.$swal('', 'O PIS/PASEP não pode ser igual ao INSS.', 'info');
                $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
                throw new Error("validacao");
              }
            }
            else {
              if (solBolsaObrigatorioPISInss) {

                if (!this.solicitacao.pertenceQuadro && (this.solicitacao.pisPasep === '' && this.solicitacao.inss === '')) {
                  this.$swal('', 'O PIS/PASEP não pode ser igual ao INSS.', 'info');
                  $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
                  throw new Error("validacao");
                }
              }
            }
            
            return valido;
          })
          .then(this.validarFuncionarioSelecionado)
          .then(this.validarPertenceQuadroUSPSelecionado)
          .then(this.$refs.dadosPagamento.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-pagamento"]').tab('show');
            }

            return valido;
          })
          .then(this.$refs.dadosBancarios.validar)
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-bancarios"]').tab('show');
            }

            return valido;
          })
          .then(valido => {
            if (this.solicitacao.rateio.projeto.travarPagamentoPfEquipe && !this.$refs.dadosCadastrais.pertenceEquipeProjeto()) {
              this.$swal("", `${this.solicitacao.nomeTerceiro} não pertence a equipe e o projeto permite apenas solicitações para membros da equipe.`, "warning");
              throw new Error('validacao');
            }
            
            return valido;
          })
          .then(this.validarTermoResponsabilidade)
          .then(this.validarAnexos)
          .then(this.validarArquivosObrigatorio)
          .then(this.enviar)
          .then(id => {
            this.$imprimirRelatorio('solicitacao-pagamento-pf.relatorio', id, 'solicitacao-pagamento-pf');
          })
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao salvar a solicitação.');
          });
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        const copiaSolicitacao = JSON.parse(JSON.stringify(this.solicitacao));

        copiaSolicitacao.arquivosDeletados = this.$refs.listaArquivos.deletados;
        
        if (this.$route.params.id) {
          return solicitacaoPagamentoServico.alterar(copiaSolicitacao, this.$refs.adicionarArquivos.arquivos, this.$route.params.idCript);
        } else {
          return solicitacaoPagamentoServico.adicionar(copiaSolicitacao, this.$refs.adicionarArquivos.arquivos);
        }
      },
      camposSolicitacao() {
        return {
          idCoordenador: '',
          dataSolicitacao: '',
          dataPagamento: '',
          documentoTerceiro: '',
          nomeTerceiro: '',
          observacao: '',
          solicitacaoEfetivada: '',
          formaPagamento: '',
          agencia: '',
          banco: '',
          contaCorrente: '',
          valor: '',
          pertenceQuadro: false,
          tipoQuadro: '',
          matricula: '',
          outroQuadro: '',
          dataNascimento: '',
          identidade: '',
          inss: '',
          pisPasep: '',
          cmc: '',
          numCmc: '',
          endereco: '',
          numero: '',
          complemento: '',
          bairro: '',
          cidade: '',
          cep: '',
          uf: '',
          telefoneResidencial: '',
          telefoneComercial: '',
          fax: '',
          tipoPagamento: '',
          statusSolicitacao: '',
          dataLiberacao: '',
          observacaoLiberacao: '',
          liberacaoCoordenador: '',
          dadosVerificados: '',
          totalReenvio: '',
          siafi: '',
          tipoConta: '',
          tipoPix: '',
          chavePix: '',
          idUsuario: '',
          pagamentoDiaria: '',
          pagamentoDeBolsa: false,
          liberacaoCoordenador2: '',
          idRubrica: '',
          idSubrubrica: '',
          idConta: '',
          idProtocolo: '',
          tipoSolicitacao: 1,
          emailTerceiro: '',
          idResponsavelSolicitacao: '',
          idUsuarioResponsavel: '',
          justicicativa: '',
          descricao: '',
          idDetalheRateio: '',
          idCategoriaFinanceira: '',
          inssOutraFonte: false,
          inssOutraFonteValor: '',
          nomeSolicitante: '',
          emailSolicitante: '',
          telefoneSolicitante: '',
          tipoSolicitacaoPagamento: null,
          funcionarioPublico: null,
          pertenceQuadroUSP: null,
          tipoQuadroUSP: null,
          regimeTrabalhoUSP: null,
          cargo: null,
          departamento: null,
          unidade: null,
          instituicaoPublica: null,
          cnpjInstituicaoPublica: null,
          cargaHorariaInstituicao: null,
          solicitacaoAnexouArquivo: null,
          solicitacaoJustificativaAnexo: null,
          tipoDocumento: '',
          notaFiscal: '',
          dataEmissao: '',
          notaFiscalPaulista: false,
          aceite: '',
          rateio: {
            idProjeto: '',
            valorRateio: '',
            idDetalheRateio: '',
            idProjetoMetaEtapa: '',
            projeto: {
              idProjeto: '',
              nomeProjeto: '',
              utilizarMetaEtapaProjeto: false,
              travarPagamentoPfEquipe: false,
            }
          }
        };
      },
      limparDadoBancario() {
        if (this.solicitacao.formaPagamento !== 0) {
          this.solicitacao.banco = '';
          this.solicitacao.agencia = '';
          this.solicitacao.contaCorrente = '';
          this.solicitacao.tipoPix = '';
          this.solicitacao.chavePix = '';
          this.solicitacao.tipoConta = '';

          this.$validator.reset();
        }
      },
      carregar(id) {
        this.carregando = true;

        let solicitacao = null;
        let idProjeto = null;

        solicitacaoPagamentoServico
          .obterPorId(id)
          .then(dados => {
            solicitacao = dados;
            idProjeto = solicitacao.rateio.idProjeto;
          })
          .then(() => this.$refs.dadosCadastrais.listaContas(idProjeto))
          .then(() => {
            if (solicitacao.rateio.projeto.utilizarMetaEtapaProjeto) {
              return this.$refs.dadosCadastrais.listaDeMetaEtapas(idProjeto);
            }
          })
          .then(() => {
            if (this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb || solicitacao.rateio.projeto.utilizarRubricaSubrubricaWeb) {
              return this.$refs.dadosCadastrais.listaDeRubricas(idProjeto);
            }
          })
          .then(() => {
            if (this.configuracao.exibirRubricaSubrubricaSolicitacaoWeb || solicitacao.rateio.projeto.utilizarRubricaSubrubricaWeb) {
              return this.$refs.dadosCadastrais.listaDeSubrubricas(idProjeto, solicitacao.idRubrica);
            }
          })
          .then(() => {
            return this.carregarDadosBancarios(solicitacao.documentoTerceiro);
          })
          .then(() => {
            return this.carregarDadosBancariosPIX(solicitacao.documentoTerceiro);
          })
          .then(() => {
            solicitacao.dataNascimento = this.$options.filters.formatarNumeroEmData(solicitacao.dataNascimento);
            solicitacao.dataPagamento = this.$options.filters.formatarNumeroEmData(solicitacao.dataPagamento);
            solicitacao.dataEmissao = this.$options.filters.formatarNumeroEmData(solicitacao.dataEmissao);
          })
          .then(() => solicitacaoPagamentoServico.arquivos(id))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            this.$set(this, 'solicitacao', solicitacao);
            this.buscaDesabilitarBeneficiario();

            if (solicitacao.tipoConta != null)
              this.$refs.dadosBancarios.setarTipoBancario(parseInt(solicitacao.tipoConta));

            this.carregando = false;
          });
      },
      carregarDadosBancarios(cpf) {
        return pessoaServico
          .dadosBancarios(cpf)
          .then(dadosBancarios => {
            this.dadosBancarios = dadosBancarios;
          })
      },
      carregarDadosBancariosPIX(cpf) {
        return pessoaServico
          .dadosBancariosPIX(cpf)
          .then(dadosBancarios => {
            this.dadosBancariosPIX = dadosBancarios;
          })
      },
      limparInssOutraFonte() {
        if (!this.solicitacao.inssOutraFonte) {
          this.solicitacao.inssOutraFonteValor = null;
        }
      },
      limparPertenceQuadro() {
        if (!this.solicitacao.pertenceQuadro) {
          this.solicitacao.tipoQuadro = '';
        }
      },
      download(arquivo) {
        solicitacaoPagamentoServico
          .download(this.$route.params.id, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },
        async validarArquivosObrigatorio(valido) {
            if (!valido) throw new Error("validacao com erro");

            if (!this.configuracao.usarArquivosSolicitacaoPagamentos)
                return true;

            if (this.configuracao.obrigatorioAnexarArquivoSolPF == false)
                return true;

            if (this.fusp() && this.solicitacao.tipoSolicitacaoPagamento !== 2)
                return true;

            var quantidadeArquivo = 0;
            var quantidadeMinimaArquivos = 1;

            for (var i = 0; i < this.$refs.adicionarArquivos.arquivos.length; i++) {
                if (this.$refs.adicionarArquivos.arquivos[i]) {
                    quantidadeArquivo += 1;
                }
            }

            if (this.$refs.listaArquivos) {
                for (var i = 0; i < this.$refs.listaArquivos.arquivos.length; i++) {
                    if (this.$refs.listaArquivos.arquivos[i]) {
                        quantidadeArquivo += 1;
                    }
                }
            }

            if (quantidadeArquivo < quantidadeMinimaArquivos) {
                $('#tabs a[href="#tab-adicionar-arquivos"]').tab('show');

                this.$swal(
                    '',
                    'É necessário anexar pelo menos ' + (quantidadeMinimaArquivos - quantidadeArquivo) + ' arquivo(s) ',
                    'info'
                );

                $('#salvar').button('reset');
                throw new Error('validacao');
            }

            return true;
      },
      fusp() {
        return this.configuracao.abreviaturaFundacao.toUpperCase() === 'FUSP';
      },
      tipoTodasSolicitacoesFUSP() {
        //return false;

        if (!this.fusp())
          return false;

        if (this.solicitacao.tipoSolicitacaoPagamento !== 4) {
          return true;
        }
      },
      validarModalidadePagamentoSelecionada(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (this.tipoTodasSolicitacoesFUSP() == false)
          return this.$validator.validateAll();

        let msgErro = "";
        let validou = true;

        if (this.solicitacao.tipoSolicitacaoPagamento == null) {
          validou = false;
        }

        if (!validou) msgErro = `É necessário selecionar a modalidade de pagamento.`

        if (msgErro) {
          $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');

          this.$swal(
            '',
            msgErro,
            'info'
          );

          throw new Error("validacao");
          return false;
        }
        else return this.$validator.validateAll();
      },
      validarFuncionarioSelecionado(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (this.tipoTodasSolicitacoesFUSP() == false)
          return this.$validator.validateAll();

        let msgErro = "";
        let validou = true;

        if (!((this.solicitacao.funcionarioPublico == 1) || (this.solicitacao.funcionarioPublico == 0))) {
          validou = false;
        }

        if (!validou) msgErro = `É necessário informar se é funcionário público.`

        if (msgErro) {
          $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');

          this.$swal(
            '',
            msgErro,
            'info'
          );

          throw new Error("validacao");
          return false;
        }
        else return this.$validator.validateAll();
      },
      validarPertenceQuadroUSPSelecionado(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (this.tipoTodasSolicitacoesFUSP() == false)
          return this.$validator.validateAll();

        if (this.solicitacao.funcionarioPublico == 0)
          return this.$validator.validateAll();

        if ((this.solicitacao.tipoSolicitacaoPagamento == 1) || (this.solicitacao.tipoSolicitacaoPagamento == 3))
          return this.$validator.validateAll();

        let msgErro = "";
        let validou = true;

        if (!((this.solicitacao.pertenceQuadroUSP == 1) || (this.solicitacao.pertenceQuadroUSP == 0))) {
          validou = false;
        }

        if (!validou) msgErro = `É necessário informar se pertence ao quadro de funcionários da USP.`

        if (msgErro) {
          $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');

          this.$swal(
            '',
            msgErro,
            'info'
          );

          throw new Error("validacao");
          return false;
        }
        else return this.$validator.validateAll();
      },
      validarTermoResponsabilidade(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (!this.habilitarOuDesabilitarTermo) return true;

        if (this.solicitacao.aceite) return true;

        $('#tabs a[href="#tab-termo"]').tab('show');

        this.$refs.termo.adicionaErroAceite();

        throw new Error("validacao");
      },
      validarAnexos(valido) {
        if (!valido) throw new Error("validacao com erro");

        if (!this.anexarCERT)
          return true;

        let msgErro = "";
        let validou = true;

        if (!((this.solicitacao.solicitacaoAnexouArquivo == 'true') || (this.solicitacao.solicitacaoAnexouArquivo == 'false'))) {
          validou = false;
        }

        if (!validou) msgErro = `É necessário informar se anexou a CERT.`

        if (msgErro) {
          $('#tabs a[href="tab-adicionar-arquivos"]').tab('show');

          this.$swal(
            '',
            msgErro,
            'info'
          );

          throw new Error("validacao");
          return false;
        }
        else return this.$validator.validateAll();
      },
    },
    created() {
      if (this.$route.params.id) {        
        this.carregar(this.$route.params.id);
        this.$set(this, 'mostrarFormulario', true);
      }
    },
    computed: {
      anexarCERTAviso() {
        return (this.solicitacao.tipoSolicitacaoPagamento == 2) && this.solicitacao.regimeTrabalhoUSP == 1;
      },
      anexarCERT() {
        return false;
        return (this.solicitacao.tipoSolicitacaoPagamento == 2) && this.solicitacao.regimeTrabalhoUSP == 1;
      },
      habilitarOuDesabilitarTermo() {
        if (!this.tipoTodasSolicitacoesFUSP())
            return false;

        return this.solicitacao.funcionarioPublico == 0 && this.fusp();
      },
      nomeTipoSolicitacao() {
        switch (this.solicitacao.tipoSolicitacaoPagamento) {
          case 1: return "diversos";
            break;
          case 2: return "RPA";
            break;
          case 3: return "";
            break;
          case 4: return "";
            break;
          case 5: return "adicional variável";
            break;
          default: return "";
            break;
        }
      }
    },
    watch: {
      'solicitacao.formaPagamento': 'limparDadoBancario',
      'solicitacao.inssOutraFonte': 'limparInssOutraFonte',
      'solicitacao.pertenceQuadro': 'limparPertenceQuadro',
      'solicitacao.solicitacaoAnexouArquivo': 'limparAnexouArquivo',
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form @submit.prevent="validarBeneficiario">

      <div class="row" v-if="mostrarFormulario">
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>
          
          <div class="tabs-container" v-show="!carregando" id="tabs">

            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab"
                   href="#tab-dados-cadastrais">
                  Dados cadastrais
                </a>
              </li>
              <li>
                <a data-toggle="tab"
                   href="#tab-dados-pagamento">
                  Dados para o pagamento
                </a>
              </li>
              <li :class="{'disabled': solicitacao.formaPagamento !== 0}">
                <a @click.prevent=""
                   :data-toggle="solicitacao.formaPagamento === 0 ? 'tab' : ''"
                   href="#tab-dados-bancarios">
                  Dados bancários
                </a>
              </li>
              <li v-if="habilitarOuDesabilitarTermo">
                <a data-toggle="tab"
                   href="#tab-termo">
                  Termo de consentimento
                </a>
              </li>
              <li v-if="configuracao.usarArquivosSolicitacaoPagamentos">
                <a data-toggle="tab"
                   href="#tab-adicionar-arquivos">
                  Adicionar arquivos
                </a>
              </li>
              <li v-if="$route.params.id && configuracao.usarArquivosSolicitacaoPagamentos">
                <a data-toggle="tab"
                   href="#tab-lista-arquivos">
                  Arquivos
                </a>
              </li>
            </ul>
            <div class="tab-content">

              <div id="tab-dados-cadastrais" class="tab-pane active">
                <div class="panel-body">
                  <dados-cadastrais ref="dadosCadastrais"
                                    :solicitacao="solicitacao"
                                    :desabilitarBeneficiario="this.desabilitarBeneficiario"
                                    :carregando="carregando"
                                    :edicao="!!$route.params.id">
                  </dados-cadastrais>
                </div>
              </div>

              <div id="tab-dados-pagamento" class="tab-pane">
                <div class="panel-body">
                  <dados-pagamento ref="dadosPagamento"
                                   :solicitacao="solicitacao"
                                   :edicao="!!$route.params.id">
                  </dados-pagamento>
                </div>
              </div>

              <div id="tab-dados-bancarios" class="tab-pane">
                <div class="panel-body">
                  <dados-bancarios ref="dadosBancarios"
                                   :solicitacao="solicitacao"
                                   :edicao="!!$route.params.id"
                                   :dadosBancarios="dadosBancarios"
                                   :dadosBancariosPIX="dadosBancariosPIX">
                  </dados-bancarios>
                </div>
              </div>

              <div id="tab-termo" class="tab-pane" v-if="habilitarOuDesabilitarTermo">
                <div class="panel-body">
                  <termo :solicitacao.sync="solicitacao"
                         ref="termo">
                  </termo>
                </div>
              </div>

              <div id="tab-adicionar-arquivos" class="tab-pane">
                <div class="panel-body">
                  <div class="alert alert-warning" role="alert" v-if="anexarCERTAviso">
                    <div class="table-responsive">
                      Quando o regime do docente for RDIDP, será necessário anexar o documento CERT atualizado.
                    </div>
                  </div>

                  <adicionar-arquivos ref="adicionarArquivos">
                  </adicionar-arquivos>

                  <div v-if="anexarCERT">
                    <div class="hr-line-dashed"></div>

                    <h3 class="m-t-none m-b margin-top-5">Arquivos anexados:</h3>

                    <div class="hr-line-dashed"></div>

                    <div class="row">
                      <div class="col-sm-2">
                        <label class="control-label required" for="anexouDocumentos">Anexou a CERT</label>

                        <div class="form-group required">
                          <radio v-model="solicitacao.solicitacaoAnexouArquivo"
                                 selected-value="true"
                                 type="success"
                                 :inline="true"
                                 class="margin-right-10"
                                 :class="[true ? '' : 'radioLeft']">
                            Sim
                          </radio>
                          <radio v-model="solicitacao.solicitacaoAnexouArquivo"
                                 selected-value="false"
                                 data-vv-name="anexouDocumentos"
                                 type="success"
                                 :inline="true">
                            Não
                          </radio>
                        </div>
                      </div>

                      <div class="col-sm-10" v-if="solicitacao.solicitacaoAnexouArquivo == 'false'">
                        <label class="control-label required" for="justificativa">Informe o motivo pelo qual o documento não foi anexado</label>

                        <div class="form-group required" :class="{'has-error': errors.has('justificativa')}">

                          <input type="text"
                                 class="form-control"
                                 id="justificativa"
                                 v-model="solicitacao.solicitacaoJustificativaAnexo"
                                 data-vv-name="justificativa"
                                 data-vv-as="Justificativa"
                                 v-validate="'required'">

                          <p class="text-danger" v-show="errors.has('justificativa')">{{ errors.first('justificativa') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div id="tab-lista-arquivos" class="tab-pane">
                <div class="panel-body">
                  <lista-de-arquivos :arquivos="arquivos"
                                     @download="download"
                                     ref="listaArquivos">
                  </lista-de-arquivos>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
      
      <div class="row" v-if="!mostrarFormulario">
        <div class="col-sm-12">
          <div class="form-group required" :class="{'has-error': errors.has('documento')}">
            <label class="control-label" for="documento">CPF do Beneficiário</label>

            <input 
              type="text"
              class="form-control"
              id="documento"
              v-model="documento"
              data-vv-as="cpf"
              data-vv-name="documento"
              v-mascara="'cpf'"
              v-validate="'required|cpf'">

            <p class="text-danger" v-show="errors.has('documento')">{{ errors.first('documento') }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link 
                class="btn btn-default" 
                :to="{ name: 'solicitacao-pagamento-pf' }" 
                v-show="!mostrarFormulario || !!$route.params.id" 
                active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button
                id="avancar"
                type="button" 
                class="btn btn-primary" 
                @click="validarBeneficiario" 
                v-show="!mostrarFormulario"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Carregando...">
              Avançar 
              <i class="fa fa-arrow-right"></i>
            </button>
            
            <button 
                type="button" 
                class="btn btn-default" 
                @click="mostrarFormulario = false, resetarComponente()" 
                v-show="mostrarFormulario && !(!!$route.params.id)">
              <i class="fa fa-arrow-left"></i>
              Volta 
            </button>

            <button 
                id="salvar"
                type="button" 
                class="btn btn-primary" 
                @click="salvar" 
                v-show="mostrarFormulario"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar 
            </button>
          </div>
        </div>
      </div>
      
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-pagamento/fisica/componentes/SolicitacaoPagamentoPfForm.vue